
export const QUESTION_TYPE_CHOICE = 'choice'
export const QUESTION_TYPE_CHOICE_CHECKBOX = 'checkbox'
export const QUESTION_TYPE_CHOICE_RADIO = 'radio'
export const QUESTION_TYPE_CHOICE_DROPDOWN = 'dropdown'

export const QUESTION_TYPE_LABEL = 'label'
export const QUESTION_TYPE_LINE = 'horizontal_line'
export const QUESTION_TYPE_NUMBER = 'number'

export const QUESTION_TYPE_READY_TO_USE = 'ready_to_use'
export const QUESTION_TYPE_READY_TO_USE_ADDRESS = 'address'
export const QUESTION_TYPE_READY_TO_USE_EMAIL = 'email'
export const QUESTION_TYPE_READY_TO_USE_PHONE = 'phone_number'
export const QUESTION_TYPE_READY_TO_USE_SHORT_NAME = 'short_name'
export const QUESTION_TYPE_READY_TO_USE_WEBSITE = 'website'

export const QUESTION_TYPE_TEXT = 'text'
export const QUESTION_TYPE_TEXT_SHORT = 'short_text'
export const QUESTION_TYPE_TEXT_PARAGRAPH = 'paragraph_text'

export const QUESTION_TYPE_TITLE = 'title'
export const QUESTION_TYPE_DESCRIPTION = 'description'

export const QUESTION_TYPE_DATE = 'date'
export const QUESTION_TYPE_BUTTON = 'submitButton'
